import { z } from 'zod';
import { Role } from './roles.js';
/**
 * The workspace policy "Require two-factor sign-in" (docs/adr/0033-two-factor-and-security-alerts.md):
 * who in the workspace has a second factor, for owners and admins. Ids, names and roles of the
 * workspace's own members only; nothing about the factors themselves.
 */
export const WorkspaceTwoFactor = z.object({
    /** The workspace's `security.requireMfa` value. */
    policy: z.enum(['off', 'admins', 'members', 'everyone']),
    items: z.array(z.object({
        userId: z.uuid(),
        name: z.string(),
        role: Role,
        hasTwoFactor: z.boolean(),
        /** Whether the policy covers this person's role. */
        required: z.boolean(),
    })),
});
/** Whether a policy requires a second factor of someone with this role. */
export function policyCovers(policy, role) {
    if (policy === 'off')
        return false;
    if (policy === 'everyone')
        return true;
    if (policy === 'members')
        return role !== 'guest';
    return role === 'owner' || role === 'admin';
}
//# sourceMappingURL=security.js.map